export default __webpack_public_path__ + "static/media/Group 1603.de68f404.png";